/**
 * 通用后进先出栈结构，作为工具栈等业务场景的基类。
 *
 * @typeParam T - 栈内元素类型
 */
export class Stack<T> {
  private readonly stack: T[]

  constructor() {
    this.stack = []
  }

  /**
   * 将元素压入栈顶。
   *
   * @param val - 待压入的元素
   */
  push(val: T): void {
    this.stack.push(val)
  }

  /**
   * 弹出并返回栈顶元素。
   *
   * @param args - 子类可选的透传参数
   * @returns 栈顶元素；栈为空时返回 undefined
   */
  pop(..._args: any[]): T | undefined {
    return this.stack.pop()
  }

  /** 清空栈内全部元素 */
  clear() {
    this.stack.length = 0
  }

  /** 栈顶元素；栈为空时为 undefined */
  get top() {
    return this.stack.length > 0 ? this.stack[this.stack.length - 1] : undefined
  }

  /** 栈底元素；栈为空时为 undefined */
  get bottom() {
    return this.stack[0]
  }

  /** 栈内元素数量 */
  get length() {
    return this.stack.length
  }

  /**
   * 判断栈是否为空。
   *
   * @returns 为空返回 true，否则返回 false
   */
  empty() {
    return this.stack.length === 0
  }

  /**
   * 按入栈顺序遍历所有元素。
   *
   * @param callback - 每个元素调用的回调，接收元素、索引、整栈数组
   */
  forEach(callback: (item: T, index: number, array: T[]) => void) {
    this.stack.forEach(callback)
  }
}
